<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Danh sách"
          :link="[
            { text: 'Cơ sở vật chất', href: '/facility' },
            { text: 'Quản lý Thiết bị & Tài sản', href: '/facility/assets' }
          ]"
        />
      </div>
      <div class="flex-center">
        <v-btn depressed dark color="primary" @click="newDialog = !newDialog">
          <v-icon left>mdi-plus</v-icon> Thêm thiết bị
        </v-btn>
      </div>
    </div>

    <div class="px-4">
      <v-card outlined class="pa-6 mb-6 elevation-0">
        <AssetFilter ref="assetFilter" @onFilterChanged="onFilterChange" />
      </v-card>

      <v-card outlined class="elevation-0">
        <AssetDataTable ref="assetDataTable" />
      </v-card>
    </div>

    <AssetNewDialog :state="newDialog" @updated="onAssetUpdated" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import AssetDataTable from '@/modules/facility/asset/AssetDataTable.vue'
import AssetFilter from '@/modules/facility/asset/AssetFilter.vue'

export default {
  name: 'FacilityAssets',
  components: {
    Breadcrumbs,
    AssetDataTable,
    AssetFilter,
    AssetNewDialog: () => import('@/modules/facility/asset/AssetNewDialog.vue')
  },
  data() {
    return {
      newDialog: false,
      currentFilter: {}
    }
  },
  created() {
    if (this.$route.query) {
      if (this.$route.query.category) {
        this.currentFilter.category = this.$route.query.category
      }
      if (this.$route.query.location) {
        this.currentFilter.location = this.$route.query.location
      }
    }
  },
  methods: {
    onFilterChange(query) {
      this.currentFilter = { ...(query || {}) }
      this.$refs.assetDataTable.refresh(this.currentFilter)
    },
    onAssetUpdated() {
      this.$refs.assetDataTable.refresh(this.currentFilter)
    }
  }
}
</script>
